import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import ReactDOM from "react-dom";

const FormularioMarinaAlicura = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const [respuestaServidor, setRespuestaServidor] = useState({
        type: "",
        message: "",
    });

    const [btnText, setBtnText] = useState("ENVIAR MENSAJE");
    const [inputDisabled, setInputDisabled] = useState(false);

    const checkPhone = (phone) => {
        if (phone.length != 9) {
            return "El teléfono debe tener 9 digitos";
        }
        if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone)) {
            return "Debes ingresar un teléfono válido";
        }
    };

    const checkRut = (rut) => {
        if (!rut) {
            return false;
        }
        // Despejar Puntos
        let valor = rut.replaceAll(".", "");
        // Despejar Guión
        valor = valor.replaceAll("-", "");

        // Aislar Cuerpo y Dígito Verificador
        const cuerpo = valor.slice(0, -1);
        let dv = valor.slice(-1).toUpperCase();

        // Formatear RUN
        rut = cuerpo + "-" + dv;

        // Si no cumple con el mínimo ej. (n.nnn.nnn)
        if (cuerpo.length < 7) {
            return "RUT Incompleto"; /* return false; */
        }

        // Calcular Dígito Verificador
        let suma = 0;
        let multiplo = 2;

        // Para cada dígito del Cuerpo
        for (let i = 1; i <= cuerpo.length; i++) {
            // Obtener su Producto con el Múltiplo Correspondiente
            let index = multiplo * valor.charAt(cuerpo.length - i);

            // Sumar al Contador General
            suma = suma + index;

            // Consolidar Múltiplo dentro del rango [2,7]
            if (multiplo < 7) {
                multiplo = multiplo + 1;
            } else {
                multiplo = 2;
            }
        }

        // Calcular Dígito Verificador en base al Módulo 11
        const dvEsperado = 11 - (suma % 11);

        // Casos Especiales (0 y K)
        dv = dv == "K" ? 10 : dv;
        dv = dv == 0 ? 11 : dv;

        // Validar que el Cuerpo coincide con su Dígito Verificador
        if (dvEsperado != dv) {
            return "RUT Inválido"; /* return false; */
        }
        return true;
        // Si todo sale bien, eliminar errores (decretar que es válido)
    };

    const formatRut = (event) => {
        event.target.value = event.target.value
            .replace(/[.-]/g, "")
            .replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, "$1.$2.$3-$4")
            .toUpperCase();
    };

    const enviarDatos = (data) => {
        event.preventDefault();
        setBtnText("ENVIANDO...");
        setInputDisabled(true);
        axios
            .post(`/envios/marina-alicura/contacto`, data)
            .then((response) => {
                const data = response.data;
                setRespuestaServidor({
                    type: "success",
                    message: data.message,
                });
                reset();
            })
            .catch((error) => {
                console.log(error.response.data.message);
                setRespuestaServidor({
                    type: "danger",
                    message: error.response.data.message,
                });
            })
            .finally(() => {
                setBtnText("ENVIAR MENSAJE");
                setInputDisabled(false);
            });
    };

    return (
        <form onSubmit={handleSubmit(enviarDatos)}>
            <div className="row g-2">
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input
                            type="text"
                            className={`form-control form-control-material
                                ${errors.nombre ? "is-invalid" : ""}`}
                            name="nombre"
                            placeholder="INGRESA TU NOMBRE"
                            disabled={inputDisabled}
                            {...register("nombre", {
                                required: "Debes ingresar tu nombre",
                            })}
                        />
                        <label htmlFor="contacto-nombre">
                            INGRESA TU NOMBRE
                        </label>
                    </div>
                    {errors.nombre && (
                        <div className="invalid-feedback">
                            {errors.nombre.message}
                        </div>
                    )}
                </div>

                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input
                            type="email"
                            className={`form-control form-control-material
                                ${errors.email ? "is-invalid" : ""}`}
                            name="email"
                            disabled={inputDisabled}
                            {...register("email", {
                                required: "Debes ingresar tu email",
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: "Debes ingresar un email válido",
                                },
                            })}
                            placeholder="INGRESA TU EMAIL"
                        />
                        <label htmlFor="contacto-email">INGRESA TU EMAIL</label>
                    </div>
                    {errors.email && (
                        <div className="invalid-feedback">
                            {errors.email.message}
                        </div>
                    )}
                </div>

                <div className="col-md-6">
                    <div className="form-floating input-group mb-3">
                        <span className="input-group-text">+56</span>
                        <input
                            type="text"
                            className={`form-control form-control-material
                                ${errors.fono ? "is-invalid" : ""}`}
                            name="fono"
                            placeholder="INGRESA TU TELÉFONO"
                            disabled={inputDisabled}
                            {...register("fono", {
                                required: "Debes ingresar tu teléfono",
                                validate: checkPhone,
                            })}
                        />
                        <label htmlFor="contacto-rut">
                            INGRESA TU TELÉFONO
                        </label>
                    </div>
                    {errors.fono && (
                        <div className="invalid-feedback">
                            {errors.fono.message}
                        </div>
                    )}
                </div>

                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input
                            type="text"
                            className={`form-control form-control-material
                                ${errors.rut ? "is-invalid" : ""}`}
                            name="rut"
                            placeholder="INGRESA TU RUT"
                            disabled={inputDisabled}
                            {...register("rut", {
                                required: "Debes ingresar tu rut",
                                validate: checkRut,
                            })}
                            onChange={formatRut}
                        />
                        <label htmlFor="contacto-rut">INGRESA TU RUT</label>
                    </div>
                    {errors.rut && (
                        <div className="invalid-feedback">
                            {errors.rut.message}
                        </div>
                    )}
                </div>

                <div className="col-12">
                    <div className="form-floating mb-3">
                        <textarea
                            className={`form-control form-control-material
                                ${errors.mensaje ? "is-invalid" : ""}`}
                            placeholder="INGRESA TU MENSAJE"
                            name="mensaje"
                            disabled={inputDisabled}
                            {...register("mensaje", {
                                required: "Debes ingresar el mensaje",
                            })}
                        ></textarea>
                        <label htmlFor="contacto-mensaje">
                            INGRESA TU MENSAJE
                        </label>
                    </div>
                    {errors.mensaje && (
                        <div className="invalid-feedback">
                            {errors.mensaje.message}
                        </div>
                    )}
                </div>
                <div className="text-center text-md-end">
                    <button
                        type="submit"
                        className="btn btn-secondary btn-block"
                    >
                        {btnText}
                    </button>
                </div>
            </div>

            {respuestaServidor.message && (
                <div className="row ">
                    <div className="col-md-4 offset-md-4">
                        <div className="respuesta-servidor">
                            <div
                                className={`alert alert-${respuestaServidor.type}`}
                                role="alert"
                            >
                                {respuestaServidor.message}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </form>
    );
};

export default FormularioMarinaAlicura;

// DOM element

if (document.getElementById("formulario-marina-alicura")) {
    ReactDOM.render(
        <FormularioMarinaAlicura />,
        document.getElementById("formulario-marina-alicura")
    );
}
